import { Stack, Typography, Box } from "@mui/material";
import { Info } from "lucide-react";
import { Customer } from "@/types/customer-type";
import {
  formatCurrency,
  getTotalOrders,
  getAveragePerOrder,
} from "./utils/customer-utils";

interface CustomerOrderHistoryInfoProps {
  customer: Customer;
}

export function CustomerOrderHistoryInfo({
  customer,
}: CustomerOrderHistoryInfoProps) {
  return (
    <Box
      sx={{
        backgroundColor: "rgba(33, 150, 243, 0.08)",
        borderRadius: 1,
        p: 1.5,
        border: "1px solid",
        borderColor: "rgba(33, 150, 243, 0.2)",
      }}
    >
      <Stack direction="row" spacing={1} alignItems="flex-start">
        <Info size={16} style={{ marginTop: 2, flexShrink: 0 }} />
        <Typography variant="body2" color="text.secondary">
          This is a repeat customer that has spent a total of{" "}
          {formatCurrency(customer.totalSpend)} across{" "}
          {getTotalOrders(customer)} orders, averaging{" "}
          {formatCurrency(getAveragePerOrder(customer))} per order.
        </Typography>
      </Stack>
    </Box>
  );
}
